<template>
  <div class="modal fade" id="modalFeatureType" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div v-if="viewType === 1" class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h5 class="title-modal">Gerar Venda </h5>
        </div>

        <div class="modal-body">
          <div class="list-info">
            <p>Começa em: <span>{{ dataFeature.startAt | formatDate }}</span></p>
            <p>Expira em: <span>{{ dataFeature.expireAt | formatDate }}</span></p>
            <p>Total de funcionários: <span>{{ dataFeature.totalEmployeeHr }}</span></p>
            <p>Valor por funcionário: <span>R{{ dataFeature.pricePerEmployeeHr | currency }}</span></p>
            <p v-if="dataFeature.totalEmployeeBeneflex">Funcionários com beneflex:
              <span>{{ dataFeature.totalEmployeeBeneflex }}</span></p>
            <p v-if="dataFeature.totalEmployeeBeneflex">Valor por
              funcionário(Beneflex)<span>R{{ dataFeature.pricePerEmployeeBeneflex }}</span></p>
            <p>Preço de cobrança: <span>R{{ dataFeature.priceToCharge | currency }}</span></p>
            <p>Preço recorrente: <span>R{{ dataFeature.recurringPrice | currency }}</span></p>
            <p>Dia recorrente: <span>{{ dataFeature.recurringDay }}</span></p>
            <p>Nota?: <span v-if="dataFeature.generateInvoice">Sim</span><span v-else>Não</span></p>
            <p v-if="dataFeature.invoiceDate">Data de emissão: <span>{{ dataFeature.invoiceDate | formatDate }}</span>
            </p>
            <p v-if="dataFeature.invoiceNotes">Observaçaõ da nota: <span>{{ dataFeature.invoiceNotes }}</span></p>
          </div>
          <div class="loading-btn" v-if="loadingFeature">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
          <div v-if="modalOpen" class="col-xs-12 col-sm-12 col-md-12 padding-null plans">
            <div class="col-md-12 feature-type-plans">
              <span>Plano: </span>
              <span v-if="dataFeature.planId === '006AE79EAC754C518548BC5F05B77CF2'">Essencial</span>
              <span v-else-if="dataFeature.planId === '00875CC4401649EEB36F253AB234525E'">Básico</span>
              <span v-else-if="dataFeature.planId === '00AD8417796E41269871612954AA8696'">Profissional</span>
              <span v-else-if="dataFeature.planId === '012ABCA6249047FFA16A9B2818E20A2F'">Premium</span>
              <span v-else-if="dataFeature.planId === '8B3B929E51BD4EB7ACEB7835BA57A5F0'">Plano 1</span>
              <span v-else-if="dataFeature.planId === 'E7D021FA8B0B441791F20E2149541F94'">Plano 2</span>
              <span v-else-if="dataFeature.planId === 'EE7BC5B1195A41E5B6394FA4CA4E46BF'">Plano 3</span>
              <span v-else>Desconhecido</span>

            </div>
            <div class="col-md-3 first-col features-plans">
              <div class="plans-header">
                <div class="plans-title">Essencial</div>
                <div class="plans-subtitle">Plano de entrada</div>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[16].isSelected = !featureList[16].isSelected">
                  <input :id="featureList[16].id" type="checkbox" v-model="featureList[16].isSelected"
                         @click="featureList[16].isSelected = !featureList[16].isSelected" disabled>
                  <label for="switch-plans"></label>
                </div>
                <label class="checkbox-label">{{ featureList[16].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[4].isSelected = !featureList[4].isSelected">
                  <input :id="featureList[4].id" type="checkbox" v-model="featureList[4].isSelected"
                         @click="featureList[4].isSelected = !featureList[4].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[4].name }}</label>
              </div>
            </div>
            <div class="col-md-3 features-plans">
              <div class="plans-header">
                <div class="plans-title">Básico</div>
                <div class="plans-subtitle">Funcionalidades do plano Essencial +</div>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[17].isSelected = !featureList[17].isSelected">
                  <input :id="featureList[17].id" type="checkbox" v-model="featureList[17].isSelected"
                         @click="featureList[17].isSelected = !featureList[17].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[17].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[8].isSelected = !featureList[8].isSelected">
                  <input :id="featureList[8].id" type="checkbox" v-model="featureList[8].isSelected"
                         @click="featureList[8].isSelected = !featureList[8].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[8].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[3].isSelected = !featureList[3].isSelected">
                  <input :id="featureList[3].id" type="checkbox" v-model="featureList[3].isSelected"
                         @click="featureList[3].isSelected = !featureList[3].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[3].name }}</label>
              </div>
            </div>
            <div class="col-md-3 features-plans">
              <div class="plans-header">
                <div class="plans-title">Profissional</div>
                <div class="plans-subtitle">Funcionalidades do plano Básico +</div>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[13].isSelected = !featureList[13].isSelected">
                  <input :id="featureList[13].id" type="checkbox" v-model="featureList[13].isSelected"
                         @click="featureList[13].isSelected = !featureList[13].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">Documentos</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[12].isSelected = !featureList[12].isSelected">
                  <input :id="featureList[12].id" type="checkbox" v-model="featureList[12].isSelected"
                         @click="featureList[12].isSelected = !featureList[12].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[12].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[5].isSelected = !featureList[5].isSelected">
                  <input :id="featureList[5].id" type="checkbox" v-model="featureList[5].isSelected"
                         @click="featureList[5].isSelected = !featureList[5].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[5].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[7].isSelected = !featureList[7].isSelected">
                  <input :id="featureList[7].id" type="checkbox" v-model="featureList[7].isSelected"
                         @click="featureList[7].isSelected = !featureList[7].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">Chat com funcionário</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[22].isSelected = !featureList[22].isSelected">
                  <input :id="featureList[22].id" type="checkbox" v-model="featureList[22].isSelected"
                         @click="featureList[22].isSelected = !featureList[22].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[22].name }}</label>
              </div>
            </div>
            <div class="col-md-3 last-col features-plans">
              <div class="plans-header">
                <div class="plans-title">Premium</div>
                <div class="plans-subtitle">Funcionalidades do plano Profissional +</div>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[10].isSelected = !featureList[10].isSelected">
                  <input :id="featureList[10].id" type="checkbox" v-model="featureList[10].isSelected"
                         @click="featureList[10].isSelected = !featureList[10].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[10].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[2].isSelected = !featureList[2].isSelected">
                  <input :id="featureList[2].id" type="checkbox" v-model="featureList[2].isSelected"
                         @click="featureList[2].isSelected = !featureList[2].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[2].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[11].isSelected = !featureList[11].isSelected">
                  <input :id="featureList[11].id" type="checkbox" v-model="featureList[11].isSelected"
                         @click="featureList[11].isSelected = !featureList[11].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[11].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[6].isSelected = !featureList[6].isSelected">
                  <input :id="featureList[6].id" type="checkbox" v-model="featureList[6].isSelected"
                         @click="featureList[6].isSelected = !featureList[6].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[6].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[15].isSelected = !featureList[15].isSelected">
                  <input :id="featureList[15].id" type="checkbox" v-model="featureList[15].isSelected"
                         @click="featureList[15].isSelected = !featureList[15].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">Ponto por MarQTab</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[14].isSelected = !featureList[14].isSelected">
                  <input :id="featureList[14].id" type="checkbox" v-model="featureList[14].isSelected"
                         @click="featureList[14].isSelected = !featureList[14].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">Personalização</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[21].isSelected = !featureList[21].isSelected">
                  <input :id="featureList[21].id" type="checkbox" v-model="featureList[21].isSelected"
                         @click="featureList[21].isSelected = !featureList[21].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">Pontos por locais</label>
              </div>
            </div>
            <div class="col-md-3 extra-col features-plans">
              <div class="plans-header">
                <div class="plans-title">Extras</div>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[0].isSelected = !featureList[0].isSelected">
                  <input :id="featureList[0].id" type="checkbox" v-model="featureList[0].isSelected"
                         @click="featureList[0].isSelected = !featureList[0].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[0].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[20].isSelected = !featureList[20].isSelected">
                  <input :id="featureList[20].id" type="checkbox" v-model="featureList[20].isSelected"
                         @click="featureList[20].isSelected = !featureList[20].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">Inconsistências (Rec Facial)</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[24].isSelected = !featureList[24].isSelected">
                  <input :id="featureList[24].id" type="checkbox" v-model="featureList[24].isSelected"
                         @click="featureList[24].isSelected = !featureList[24].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[24].name }}</label>
              </div>
              <div class="new-checkbox">
                <div class="switch-plans" v-on:click="featureList[23].isSelected = !featureList[23].isSelected">
                  <input :id="featureList[23].id" type="checkbox" v-model="featureList[23].isSelected"
                         @click="featureList[23].isSelected = !featureList[23].isSelected" disabled>
                  <label for="switch-p"></label>
                </div>
                <label class="checkbox-label">{{ featureList[23].name }}</label>
              </div>
            </div>
          </div>

          <!--                    <div v-on:click="d.isSelected = !d.isSelected" v-for="d in featureList" class="checkbox inline-block"-->
          <!--                         v-bind:class="{'inline-checked': d.isSelected}">-->
          <!--                      <input v-bind:id="d.featureId" type="checkbox" v-model="d.isSelected"-->
          <!--                             v-on:click="d.isSelected = !d.isSelected">-->
          <!--                      <label>{{ d.name }}</label>-->
          <!--                    </div>-->
        </div>

        <div class="modal-footer">
          <button v-on:click="checkFeatures()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Salvar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>

      <div v-if="viewType === 2" class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h5 class="title-modal">Boleto gerado com sucesso.</h5>
        </div>

        <div class="modal-body">
          <div class="list-info">
            <p class="link-payment">Link: <span><a v-bind:href="uriBoleto" target="_blank">{{ uriBoleto }}</a></span>
            </p>
          </div>
          <div class="modal-footer">
            <button v-on:click="closeModal()" class="close-btn">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CHANGE_FINANCIAL_EMAIL,
  FEATURE_PLAN,
  PAYMENT,
  SALES_INFORMATION
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../utils";
import swal from "sweetalert";

export default {
  name: "modalFeatureType",
  props: ['objToModal'],
  data() {
    return {
      modalOpen: false,
      viewType: 1,
      featureList: [],
      dataFeature: {},
      context: '',
      resetInputs: '',
      uriBoleto: '',
      loadingChange: false,
      loadingFeature: false
    }
  },
  watch: {
    objToModal: function (val) {
      this.viewType = 1;
      this.dataFeature = val;
      this.context = val.context;
      this.loadDataPlan(val.planId, val.context);
    },
    resetInputs: function (val) {
      this.$emit('update:resetInputPayment', val)
    },
    uriBoleto: function (val) {
      this.$emit('update:reloadFunction', val)
    },
  },
  methods: {
    checkFeatures() {
      this.dataFeature.featureIds = [];
      this.featureList.map((value, index) => {
        if (value.isSelected) {
          this.dataFeature.featureIds.push(value.featureId);
        }
        if (this.featureList.length === index + 1) {
          if (!this.loadingChange) {
            this.loadingChange = true;
            this.dataFeature.featureIds = `[${this.dataFeature.featureIds}]`;
            UTIL_SERVICE.console("data send:", this.dataFeature);
            REQUEST_SERVICE.requestContext('POST', SALES_INFORMATION, this.context, this.dataFeature).then((response) => {
              UTIL_SERVICE.console("RESULT PAYMENT:", response.data);

              this.loadingChange = false;
              this.uriBoleto = response.data;

              this.resetInputs = Math.floor(Math.random() * 101);
              this.viewType = 2;
              swal("Aviso", "Boleto gerado com sucesso", "success").then(() => {
                location.reload();
              });
            }).catch((reason) => {
              this.loadingChange = false;
              this.closeModal();
              swal({
                title: "Ops...",
                text: reason.response.data.erros[0].value,
                button: "Confirmar",
                icon: 'error'
              });
            });
          }
        }
      });
    },
    loadDataPlan(planId, context) {
      let url = FEATURE_PLAN + planId;
      this.loadingFeature = true;
      REQUEST_SERVICE.requestContext('GET', url, context).then((response) => {
        UTIL_SERVICE.console("RESULT FEATURE_PLAN:", response.data);

        this.featureList = response.data;
        this.loadingFeature = false;
        this.modalOpen = true

      }).catch((reason) => {
        this.loadingFeature = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    closeModal() {
      $('#modalFeatureType').modal('toggle');
    }
  }
}
</script>

<style lang="scss">
#modalFeatureType {
  @media (min-width: 768px) {
    .modal-dialog {
      width: 900px;
      margin: 30px auto;
    }
  }

  h4 {
    border-top: 1px solid #eee;
    padding-top: 20px;
    margin-bottom: 20px;
    text-align: left;
  }

  .inline-block {
    display: inline-block;
    cursor: pointer;
    padding: 7px 20px 8px 40px !important;
    min-width: 200px;
    border: 1px solid #e6e9ec;
    border-radius: 25px !important;
    margin-left: 0;
    margin-bottom: 20px;
    margin-right: 10px;
    width: 300px;

    label {
      cursor: pointer;

      &:after {
        top: -1px;
        margin-left: -23px;
      }

      &:before {
        border-radius: 25px !important;
        margin-left: -24px;
      }
    }
  }

  .inline-checked {
    background: #00a651;

    label {
      color: #fff !important;

      &:after {
        color: #00a651 !important;
      }
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  a {
    margin-bottom: 20px;
    display: block;
    color: #3598dc;
  }

  .list-info {
    padding-top: 10px;

    p {
      display: inline-flex;
      width: calc(100% / 2 - 20px);
      margin: 0 0 20px;

      span {
        display: inline-block;
        margin-left: 4px;
        font-weight: 600;
        overflow-wrap: anywhere;
      }
    }

    .link-payment {
      width: 100%;
    }
  }

  .checkbox {
    display: inline-flex;
    width: calc(100% / 3 - 30px);
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding: 0 20px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}

.plans {
  margin: 40px 0 50px 0;

  .col-xs-12, .col-sm-12, .col-md-12, {
    padding: 0;
  }

  .first-col {
    padding-left: 0;
  }

  .last-col {
    padding-right: 0;
  }

  .extra-col {
    position: absolute;
    bottom: -78px;

    padding-left: 0;

  }

  .feature-type-plans {
    color: var(--dark-gray);
    font-size: 21px;
    font-weight: 400;

    span {
      font-weight: 700;
    }
  }

  .features-plans {
    display: flex;
    flex-direction: column;

    .plans-header {
      color: var(--dark-gray);

      .plans-title {
        font-weight: 400;
        font-size: 21px;
        padding-bottom: 8px;
        margin: 16px 0 8px 0;
        border-bottom: 1px solid var(--dark-gray);
      }

      .plans-subtitle {
        font-weight: 700;
        font-size: 14px;
      }
    }

    .new-checkbox {
      margin: 16px 0 0 0;
      display: flex;
      align-items: center;
      padding: 8.5px 8px;
      border: 1px solid #E6E9EC;
      border-radius: 18px !important;

      .switch-plans {
        input {
          display: none;
        }

        label {
          display: flex;
          align-items: center;
          width: 34px;
          height: 21px;
          background-color: #E6E9EC;
          position: relative;
          cursor: pointer;
          border-radius: 1.6rem !important;
          margin: 0;

          &::after {
            content: "";
            position: absolute;
            left: .3rem;
            width: 15px;
            height: 15px;
            border-radius: 50% !important;
            background: #9baacf;
            transition: all .4s ease;
          }

          &::before {
            content: "";
            width: 100%;
            height: 100%;
            border-radius: inherit !important;
            background: #2F23D6;
            opacity: 0;
            transition: all .4s ease;
          }
        }
      }

      & input:checked {
        & ~ label {
          &::before {
            opacity: 1;
          }

          &::after {
            left: 1.6rem;
            background: #ffffff;
          }
        }
      }
    }

    .checkbox-label {
      margin: 0 0 0 10px;
      font-weight: 400;
      font-size: 13px;
      color: #3A424E;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalFeatureType.vue